var countryAndCode = [
  { name: { common: 'Grenada' }, countryCode: 'GD' },
  { name: { common: 'Malaysia' }, countryCode: 'MY' },
  { name: { common: 'French Guiana' }, countryCode: 'GF' },
  { name: { common: 'Spain' }, countryCode: 'ES' },
  { name: { common: 'Cook Islands' }, countryCode: 'CK' },
  { name: { common: 'Mali' }, countryCode: 'ML' },
  { name: { common: 'Libya' }, countryCode: 'LY' },
  { name: { common: 'Western Sahara' }, countryCode: 'EH' },
  { name: { common: 'Solomon Islands' }, countryCode: 'SB' },
  { name: { common: 'Tunisia' }, countryCode: 'TN' },
  { name: { common: 'Guernsey' }, countryCode: 'GG' },
  { name: { common: 'Seychelles' }, countryCode: 'SC' },
  { name: { common: 'British Virgin Islands' }, countryCode: 'VG' },
  { name: { common: 'Georgia' }, countryCode: 'GE' },
  { name: { common: 'Guadeloupe' }, countryCode: 'GP' },
  { name: { common: 'Syria' }, countryCode: 'SY' },
  { name: { common: 'Norway' }, countryCode: 'NO' },
  { name: { common: 'Philippines' }, countryCode: 'PH' },
  { name: { common: 'Iceland' }, countryCode: 'IS' },
  { name: { common: 'Mozambique' }, countryCode: 'MZ' },
  { name: { common: 'Palau' }, countryCode: 'PW' },
  { name: { common: 'Afghanistan' }, countryCode: 'AF' },
  { name: { common: 'Djibouti' }, countryCode: 'DJ' },
  { name: { common: 'Peru' }, countryCode: 'PE' },
  { name: { common: 'Luxembourg' }, countryCode: 'LU' },
  { name: { common: 'Burundi' }, countryCode: 'BI' },
  { name: { common: 'Guyana' }, countryCode: 'GY' },
  { name: { common: 'United Kingdom' }, countryCode: 'GB' },
  { name: { common: 'Cocos (Keeling) Islands' }, countryCode: 'CC' },
  { name: { common: 'Palestine' }, countryCode: 'PS' },
  { name: { common: 'Pitcairn Islands' }, countryCode: 'PN' },
  { name: { common: 'Barbados' }, countryCode: 'BB' },
  { name: { common: 'Kiribati' }, countryCode: 'KI' },
  { name: { common: 'South Africa' }, countryCode: 'ZA' },
  { name: { common: 'Mongolia' }, countryCode: 'MN' },
  { name: { common: 'Cyprus' }, countryCode: 'CY' },
  { name: { common: 'Mauritius' }, countryCode: 'MU' },
  { name: { common: 'Antigua and Barbuda' }, countryCode: 'AG' },
  { name: { common: 'Saint Martin' }, countryCode: 'MF' },
  { name: { common: 'Réunion' }, countryCode: 'RE' },
  { name: { common: 'Bermuda' }, countryCode: 'BM' },
  { name: { common: 'Monaco' }, countryCode: 'MC' },
  { name: { common: 'Curaçao' }, countryCode: 'CW' },
  { name: { common: 'Jersey' }, countryCode: 'JE' },
  { name: { common: 'Cambodia' }, countryCode: 'KH' },
  { name: { common: 'Sudan' }, countryCode: 'SD' },
  { name: { common: 'Guinea' }, countryCode: 'GN' },
  { name: { common: 'Turks and Caicos Islands' }, countryCode: 'TC' },
  { name: { common: 'Martinique' }, countryCode: 'MQ' },
  { name: { common: 'Slovenia' }, countryCode: 'SI' },
  { name: { common: 'Iran' }, countryCode: 'IR' },
  { name: { common: 'Sweden' }, countryCode: 'SE' },
  { name: { common: 'Bangladesh' }, countryCode: 'BD' },
  { name: { common: 'South Georgia' }, countryCode: 'GS' },
  { name: { common: 'United States Virgin Islands' }, countryCode: 'VI' },
  { name: { common: 'French Southern and Antarctic Lands' }, countryCode: 'TF' },
  { name: { common: 'Maldives' }, countryCode: 'MV' },
  { name: { common: 'Greece' }, countryCode: 'GR' },
  { name: { common: 'Estonia' }, countryCode: 'EE' },
  { name: { common: 'Malta' }, countryCode: 'MT' },
  { name: { common: 'French Polynesia' }, countryCode: 'PF' },
  { name: { common: 'Saint Lucia' }, countryCode: 'LC' },
  { name: { common: 'Rwanda' }, countryCode: 'RW' },
  { name: { common: 'Russia' }, countryCode: 'RU' },
  { name: { common: 'Belarus' }, countryCode: 'BY' },
  { name: { common: 'Croatia' }, countryCode: 'HR' },
  { name: { common: 'Saint Barthélemy' }, countryCode: 'BL' },
  { name: { common: 'Gibraltar' }, countryCode: 'GI' },
  { name: { common: 'Heard Island and McDonald Islands' }, countryCode: 'HM' },
  { name: { common: 'Chile' }, countryCode: 'CL' },
  { name: { common: 'Armenia' }, countryCode: 'AM' },
  { name: { common: 'Haiti' }, countryCode: 'HT' },
  { name: { common: 'DR Congo' }, countryCode: 'CD' },
  { name: { common: 'Guam' }, countryCode: 'GU' },
  { name: { common: 'Åland Islands' }, countryCode: 'AX' },
  { name: { common: 'Iraq' }, countryCode: 'IQ' },
  { name: { common: 'Denmark' }, countryCode: 'DK' },
  { name: { common: 'Nigeria' }, countryCode: 'NG' },
  { name: { common: 'Malawi' }, countryCode: 'MW' },
  { name: { common: 'Colombia' }, countryCode: 'CO' },
  { name: { common: 'Guatemala' }, countryCode: 'GT' },
  { name: { common: 'Falkland Islands' }, countryCode: 'FK' },
  { name: { common: 'Trinidad and Tobago' }, countryCode: 'TT' },
  { name: { common: 'North Korea' }, countryCode: 'KP' },
  { name: { common: 'Tuvalu' }, countryCode: 'TV' },
  { name: { common: 'Indonesia' }, countryCode: 'ID' },
  { name: { common: 'Ethiopia' }, countryCode: 'ET' },
  { name: { common: 'Bolivia' }, countryCode: 'BO' },
  { name: { common: 'Sierra Leone' }, countryCode: 'SL' },
  { name: { common: 'Montenegro' }, countryCode: 'ME' },
  { name: { common: 'Australia' }, countryCode: 'AU' },
  { name: { common: 'Republic of the Congo' }, countryCode: 'CG' },
  { name: { common: 'Burkina Faso' }, countryCode: 'BF' },
  { name: { common: 'Israel' }, countryCode: 'IL' },
  { name: { common: 'Uruguay' }, countryCode: 'UY' },
  { name: { common: 'Ireland' }, countryCode: 'IE' },
  { name: { common: 'Christmas Island' }, countryCode: 'CX' },
  { name: { common: 'Caribbean Netherlands' }, countryCode: 'BQ' },
  { name: { common: 'Taiwan' }, countryCode: 'TW' },
  { name: { common: 'Botswana' }, countryCode: 'BW' },
  { name: { common: 'Zambia' }, countryCode: 'ZM' },
  { name: { common: 'Gabon' }, countryCode: 'GA' },
  { name: { common: 'Finland' }, countryCode: 'FI' },
  { name: { common: 'Macau' }, countryCode: 'MO' },
  { name: { common: 'Antarctica' }, countryCode: 'AQ' },
  { name: { common: 'El Salvador' }, countryCode: 'SV' },
  { name: { common: 'United States' }, countryCode: 'US' },
  { name: { common: 'Marshall Islands' }, countryCode: 'MH' },
  { name: { common: 'Fiji' }, countryCode: 'FJ' },
  { name: { common: 'Germany' }, countryCode: 'DE' },
  { name: { common: 'Belize' }, countryCode: 'BZ' },
  { name: { common: 'Zimbabwe' }, countryCode: 'ZW' },
  { name: { common: 'Qatar' }, countryCode: 'QA' },
  { name: { common: 'Anguilla' }, countryCode: 'AI' },
  { name: { common: 'Angola' }, countryCode: 'AO' },
  { name: { common: 'Italy' }, countryCode: 'IT' },
  { name: { common: 'Togo' }, countryCode: 'TG' },
  { name: { common: 'Northern Mariana Islands' }, countryCode: 'MP' },
  { name: { common: 'New Zealand' }, countryCode: 'NZ' },
  { name: { common: 'Myanmar' }, countryCode: 'MM' },
  { name: { common: 'Oman' }, countryCode: 'OM' },
  { name: { common: 'Samoa' }, countryCode: 'WS' },
  { name: { common: 'Benin' }, countryCode: 'BJ' },
  { name: { common: 'Saint Kitts and Nevis' }, countryCode: 'KN' },
  { name: { common: 'Mauritania' }, countryCode: 'MR' },
  { name: { common: 'United States Minor Outlying Islands' }, countryCode: 'UM' },
  { name: { common: 'Greenland' }, countryCode: 'GL' },
  { name: { common: 'Bosnia and Herzegovina' }, countryCode: 'BA' },
  { name: { common: 'Eswatini' }, countryCode: 'SZ' },
  { name: { common: 'Vatican City' }, countryCode: 'VA' },
  { name: { common: 'France' }, countryCode: 'FR' },
  { name: { common: 'Poland' }, countryCode: 'PL' },
  { name: { common: 'Comoros' }, countryCode: 'KM' },
  { name: { common: 'Papua New Guinea' }, countryCode: 'PG' },
  { name: { common: 'Kenya' }, countryCode: 'KE' },
  { name: { common: 'Vietnam' }, countryCode: 'VN' },
  { name: { common: 'Vanuatu' }, countryCode: 'VU' },
  { name: { common: 'Guinea-Bissau' }, countryCode: 'GW' },
  { name: { common: 'Saint Pierre and Miquelon' }, countryCode: 'PM' },
  { name: { common: 'Saint Helena, Ascension and Tristan da Cunha' }, countryCode: 'SH' },
  { name: { common: 'Uganda' }, countryCode: 'UG' },
  { name: { common: 'Uzbekistan' }, countryCode: 'UZ' },
  { name: { common: 'New Caledonia' }, countryCode: 'NC' },
  { name: { common: 'Paraguay' }, countryCode: 'PY' },
  { name: { common: 'Canada' }, countryCode: 'CA' },
  { name: { common: 'Niue' }, countryCode: 'NU' },
  { name: { common: 'Thailand' }, countryCode: 'TH' },
  { name: { common: 'Austria' }, countryCode: 'AT' },
  { name: { common: 'Bahrain' }, countryCode: 'BH' },
  { name: { common: 'Nepal' }, countryCode: 'NP' },
  { name: { common: 'Algeria' }, countryCode: 'DZ' },
  { name: { common: 'Kazakhstan' }, countryCode: 'KZ' },
  { name: { common: 'Laos' }, countryCode: 'LA' },
  { name: { common: 'Kosovo' }, countryCode: 'XK' },
  { name: { common: 'Ivory Coast' }, countryCode: 'CI' },
  { name: { common: 'Cayman Islands' }, countryCode: 'KY' },
  { name: { common: 'Chad' }, countryCode: 'TD' },
  { name: { common: 'Turkmenistan' }, countryCode: 'TM' },
  { name: { common: 'Puerto Rico' }, countryCode: 'PR' },
  { name: { common: 'Brazil' }, countryCode: 'BR' },
  { name: { common: 'Romania' }, countryCode: 'RO' },
  { name: { common: 'Sint Maarten' }, countryCode: 'SX' },
  { name: { common: 'Switzerland' }, countryCode: 'CH' },
  { name: { common: 'São Tomé and Príncipe' }, countryCode: 'ST' },
  { name: { common: 'Pakistan' }, countryCode: 'PK' },
  { name: { common: 'Turkey' }, countryCode: 'TR' },
  { name: { common: 'Suriname' }, countryCode: 'SR' },
  { name: { common: 'Norfolk Island' }, countryCode: 'NF' },
  { name: { common: 'Singapore' }, countryCode: 'SG' },
  { name: { common: 'Tanzania' }, countryCode: 'TZ' },
  { name: { common: 'Micronesia' }, countryCode: 'FM' },
  { name: { common: 'Slovakia' }, countryCode: 'SK' },
  { name: { common: 'Hong Kong' }, countryCode: 'HK' },
  { name: { common: 'Albania' }, countryCode: 'AL' },
  { name: { common: 'India' }, countryCode: 'IN' },
  { name: { common: 'Nicaragua' }, countryCode: 'NI' },
  { name: { common: 'Japan' }, countryCode: 'JP' },
  { name: { common: 'Argentina' }, countryCode: 'AR' },
  { name: { common: 'Cape Verde' }, countryCode: 'CV' },
  { name: { common: 'Moldova' }, countryCode: 'MD' },
  { name: { common: 'Panama' }, countryCode: 'PA' },
  { name: { common: 'Svalbard and Jan Mayen' }, countryCode: 'SJ' },
  { name: { common: 'Tonga' }, countryCode: 'TO' },
  { name: { common: 'Saint Vincent and the Grenadines' }, countryCode: 'VC' },
  { name: { common: 'Czechia' }, countryCode: 'CZ' },
  { name: { common: 'Madagascar' }, countryCode: 'MG' },
  { name: { common: 'Belgium' }, countryCode: 'BE' },
  { name: { common: 'Hungary' }, countryCode: 'HU' },
  { name: { common: 'Dominican Republic' }, countryCode: 'DO' },
  { name: { common: 'Egypt' }, countryCode: 'EG' },
  { name: { common: 'Nauru' }, countryCode: 'NR' },
  { name: { common: 'Cameroon' }, countryCode: 'CM' },
  { name: { common: 'Jamaica' }, countryCode: 'JM' },
  { name: { common: 'Bouvet Island' }, countryCode: 'BV' },
  { name: { common: 'Saudi Arabia' }, countryCode: 'SA' },
  { name: { common: 'Azerbaijan' }, countryCode: 'AZ' },
  { name: { common: 'Jordan' }, countryCode: 'JO' },
  { name: { common: 'Lithuania' }, countryCode: 'LT' },
  { name: { common: 'Isle of Man' }, countryCode: 'IM' },
  { name: { common: 'Equatorial Guinea' }, countryCode: 'GQ' },
  { name: { common: 'Costa Rica' }, countryCode: 'CR' },
  { name: { common: 'Cuba' }, countryCode: 'CU' },
  { name: { common: 'Dominica' }, countryCode: 'DM' },
  { name: { common: 'Central African Republic' }, countryCode: 'CF' },
  { name: { common: 'Namibia' }, countryCode: 'NA' },
  { name: { common: 'Tokelau' }, countryCode: 'TK' },
  { name: { common: 'Montserrat' }, countryCode: 'MS' },
  { name: { common: 'Serbia' }, countryCode: 'RS' },
  { name: { common: 'Kuwait' }, countryCode: 'KW' },
  { name: { common: 'Niger' }, countryCode: 'NE' },
  { name: { common: 'San Marino' }, countryCode: 'SM' },
  { name: { common: 'Ukraine' }, countryCode: 'UA' },
  { name: { common: 'Bhutan' }, countryCode: 'BT' },
  { name: { common: 'Yemen' }, countryCode: 'YE' },
  { name: { common: 'Venezuela' }, countryCode: 'VE' },
  { name: { common: 'Morocco' }, countryCode: 'MA' },
  { name: { common: 'Brunei' }, countryCode: 'BN' },
  { name: { common: 'Senegal' }, countryCode: 'SN' },
  { name: { common: 'South Sudan' }, countryCode: 'SS' },
  { name: { common: 'Netherlands' }, countryCode: 'NL' },
  { name: { common: 'Liechtenstein' }, countryCode: 'LI' },
  { name: { common: 'Andorra' }, countryCode: 'AD' },
  { name: { common: 'Lebanon' }, countryCode: 'LB' },
  { name: { common: 'Latvia' }, countryCode: 'LV' },
  { name: { common: 'North Macedonia' }, countryCode: 'MK' },
  { name: { common: 'Portugal' }, countryCode: 'PT' },
  { name: { common: 'Mexico' }, countryCode: 'MX' },
  { name: { common: 'Bahamas' }, countryCode: 'BS' },
  { name: { common: 'Mayotte' }, countryCode: 'YT' },
  { name: { common: 'China' }, countryCode: 'CN' },
  { name: { common: 'Kyrgyzstan' }, countryCode: 'KG' },
  { name: { common: 'Wallis and Futuna' }, countryCode: 'WF' },
  { name: { common: 'Gambia' }, countryCode: 'GM' },
  { name: { common: 'Timor-Leste' }, countryCode: 'TL' },
  { name: { common: 'Eritrea' }, countryCode: 'ER' },
  { name: { common: 'Tajikistan' }, countryCode: 'TJ' },
  { name: { common: 'Sri Lanka' }, countryCode: 'LK' },
  { name: { common: 'Bulgaria' }, countryCode: 'BG' },
  { name: { common: 'Lesotho' }, countryCode: 'LS' },
  { name: { common: 'British Indian Ocean Territory' }, countryCode: 'IO' },
  { name: { common: 'South Korea' }, countryCode: 'KR' },
  { name: { common: 'Somalia' }, countryCode: 'SO' },
  { name: { common: 'Ghana' }, countryCode: 'GH' },
  { name: { common: 'American Samoa' }, countryCode: 'AS' },
  { name: { common: 'Liberia' }, countryCode: 'LR' },
  { name: { common: 'Faroe Islands' }, countryCode: 'FO' },
  { name: { common: 'United Arab Emirates' }, countryCode: 'AE' },
  { name: { common: 'Honduras' }, countryCode: 'HN' },
  { name: { common: 'Ecuador' }, countryCode: 'EC' },
  { name: { common: 'Aruba' }, countryCode: 'AW' },
]

export default countryAndCode
